import {
  get,
  post,
  destroy,
  put,
} from './index';

import cleanUpObject from '../cleanUpObject';

// Attention: this function returns response.json()
export const getTags = (organizationId, params) => {
  let queryParamString = {
    organization_id: organizationId,
    include_site_data: params.includeSiteData || false,
    name: params.name || '',
    sort: params.sortBy || '',
    ordering: params.direction || '',
    per_page: params.perPage || 20,
    page: params.page || 1,
  };
  cleanUpObject(queryParamString);
  queryParamString = new URLSearchParams(queryParamString).toString();
  return get(`/api/v3/tags?${queryParamString}`);
};

export const deleteTag = (organizationId, tagId) => {
  destroy(`/api/v3/tags/${tagId}?organization_id=${organizationId}`);
};

/**
 * Send request to create a new tag
 * @param {object} data Tag data
 * @param {number} orgId Organization ID
 * @returns Promise with HTTP response
 */
export const createTag = (data, orgId) => post(`/api/v3/tags?organization_id=${orgId}`, data);

/**
 * Send request to associate a tag with a site
 * @param {number} tagId - ID of the tag
 * @param {number} orgId - Organization ID
 * @param {number[]} siteIds - Array of site IDs to associate with the tag
 * @returns {Promise} - Promise with HTTP response
 */
export const addSitesToTag = (tagId, orgId, siteIds) => {
  const tagSiteData = {
    tag_site: {
      site_ids: siteIds,
    },
  };

  return post(`/api/v3/tags/${tagId}/sites?organization_id=${orgId}`, tagSiteData);
};

/**
 * Send request to bulk associate tags and sites
 * @param {number[]} tagIds - Array of tag IDs to associate with the site
 * @param {number} orgId - Organization ID
 * @param {number[]} siteIds - Array of site IDs to associate with the tag
 * @returns {Promise} - Promise with HTTP response
 */
export const bulkAssociateTagsSites = (orgId, tagIds, siteIds) => {
  const tagsSitesData = {
    tag_ids: tagIds,
    site_ids: siteIds,
  };

  return post(`/api/v3/tags_sites?organization_id=${orgId}`, tagsSitesData);
};

/**
 * Send request to update an existing tag
 * @param {number} tagId - ID of the tag to update
 * @param {number} orgId - Organization ID
 * @param {object} data - The updated tag data
 * @returns {Promise} - Promise with HTTP response
 */
export const updateTag = (tagId, orgId, data) => {
  return put(`/api/v3/tags/${tagId}?organization_id=${orgId}`, data, 'PUT');
};

/**
 * Send request to get tag info & relevant site(s)
 * @param {number} tagId - ID of the tag
 * @param {number} orgId - Organization ID
 * @returns {Promise} - Promise with HTTP response
 */

export const getTagInfo = (tagId, orgId, extra = {}) => {
  const params = new URLSearchParams({ organization_id: orgId, include_site_data: true, ...extra }).toString();
  return get(`/api/v3/tags/${tagId}?${params}`);
};

export const getTagById = (tagId, orgId) => {
  return get(`/api/v3/tags/${tagId}?organization_id=${orgId}`);
};
